<template>
  <div
    class="home"
    :showGameIng="this.showGameIng"
    style="background-color: #cfded5;height: 100%; position: relative;overflow-x: hidden;"
  >
    <!-- 球場ing 選單 -->
    <van-overlay :show="showGameIng" @click="showGameIng = false">
      <div class="wrapper">
        <div class="block">
          <div style="padding:1rem">
            正在進行的球賽：
            <van-button
              class="buttonListItem"
              round
              type="info"
              v-for="(data, index) in allCompetesDatasFilterJoin"
              :key="index"
              @click="toRecordCardRouter(data.allKey)"
              >{{ data.game_name }}</van-button
            >
          </div>
        </div>
      </div>
    </van-overlay>
    <div>
      <!-- 跑馬燈區 -->
      <van-swipe id="swipe" class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item
          class="banner"
          :style="{ background: 'url(' + require('../assets/adImg/GolfouritPxg.jpg') + ') ' }"
          @click="toPartnerPagePxg"
        ></van-swipe-item>
        <van-swipe-item
          class="banner"
          :style="{ background: 'url(' + require('../assets/GOLFOURIT1200x628-2.png') + ') ' }"
          @click="toPartnerPage"
        ></van-swipe-item>
        <van-swipe-item
          class="banner"
          :style="{ background: 'url(' + require('../assets/adImg/carBanner.png') + ') ' }"
          @click="toAdPage('car')"
        ></van-swipe-item>

        <van-swipe-item
          class="banner"
          :style="{ background: 'url(' + require('../assets/adImg/FumonBanner.jpg') + ') ' }"
          @click="toAdPage('fumon')"
        ></van-swipe-item>
        <van-swipe-item
          class="banner"
          :style="{ background: 'url(' + require('../assets/GOLFOURITCours.jpg') + ') ' }"
          @click="toCourseInfoPage"
        ></van-swipe-item>
      </van-swipe>
    </div>

    <!-- 按鈕區 -->
    <div class="btn_box_title">熱門推薦</div>

    <div
      class="tem-flex"
      style="display: flex;flex-wrap: wrap;justify-content: space-between;padding: 0 1rem;text-align: center;"
    >
      <div
        v-for="(value, index) in this.itemData"
        :key="index"
        @click="value.fun()"
        class="tem-list"
      >
        <div
          v-if="index < 4"
          class="home_hot_btn"
          :style="{ background: 'url(' + value.img + ')' }"
        ></div>
        <div
          v-else
          class="home_hot_btn home_hot_btn2"
          :style="{ background: 'url(' + value.img + ')' }"
        ></div>
        <div v-if="index < 4" style="text-align: center;font-size:.75rem;">{{ value.text }}</div>
      </div>
    </div>

    <!-- 好康區 -->
    <div class="btn_box_title" style="margin-top:2rem">影片精選 PGA Tour</div>
    <div style="padding:.5rem;white-space:nowrap;overflow-x: scroll;margin-bottom:5rem">
      <div
        class="PGA_box"
        v-for="(pga, index) in this.pgaData"
        :key="index"
        :style="{ background: 'url(' + pga.pic + ')' }"
        @click="pga.click()"
      >
        <div class="PGA_box_w">
          <span style="font-size:1.1rem">{{ pga.title }}</span>
          <br />
          <span style="font-size:.7rem">{{ pga.winner }}</span>
          <br />
          <span style="font-size:.9rem">點我看影片</span>
        </div>
      </div>
    </div>

    <!-- 開局計分 表單 -->
    <showOpenGameOption :data="this.showSelectType" />
    <!-- 合作洽談 表單 -->
    <notifyGolfouritForm :data="this.notifyGolfouritFormData" />
  </div>
</template>

<script>
  // @ is an alias to /src
  import showOpenGameOption from '../components/showOpenGameOption';
  import notifyGolfouritForm from '../components/notifyGolfouritForm';
  import { mapGetters } from 'vuex';
  import { Dialog } from 'vant';
  import moment from 'moment';
  export default {
    name: 'Home',
    data() {
      return {
        notifyGolfouritFormData: {
          name: '合作洽談',
          active: false,
        },
        showSelectType: {
          name: '開局計分表單',
          active: false,
        },
        showGameIng: false,
        itemData: [
          {
            text: '計分卡ing',
            img:
              'https://firebasestorage.googleapis.com/v0/b/golf-67815.appspot.com/o/AD%2F%E8%A8%88%E5%88%86%E5%8D%A1logo.png?alt=media&token=6874ed72-83d7-4784-b2ad-e770551f3acb',
            fun: () => {
              if (this.allCompetesDatasFilterJoin.length == 0) {
                Dialog.alert({
                  message: '沒有正在進行的球賽哦!',
                  confirmButtonText: '確認',
                });
              } else this.showGameIng = true;
            },
          },
          {
            text: '開局計分',
            img:
              'https://firebasestorage.googleapis.com/v0/b/golf-67815.appspot.com/o/AD%2F%E4%B8%89%E7%BC%BA%E4%B8%80logo.png?alt=media&token=17ff20ea-d94e-4ff3-aace-4314f2be5549',
            fun: () => (this.showSelectType.active = true),
          },
          {
            text: '球場資訊',
            img:
              'https://firebasestorage.googleapis.com/v0/b/golf-67815.appspot.com/o/AD%2F%E5%A4%A9%E6%B0%A3logo.png?alt=media&token=a4f0bb3d-e5a6-45a8-9791-e887a0760697',
            path: '',
            fun: () => this.$router.push({ name: 'courseInfo' }),
          },
          {
            text: 'TPGA',
            img:
              'https://firebasestorage.googleapis.com/v0/b/golf-67815.appspot.com/o/PGA.1.png?alt=media&token=64d13363-d611-4b4f-83e3-44e06d11b211',
            fun: () => {
              this.$liff.openWindow({
                url: 'https://liff.line.me/1650128613-PXabg9Lm',
                external: false,
              });
            },
          },
          // {
          //   text: '合作洽談',
          //   img:
          //     'https://firebasestorage.googleapis.com/v0/b/golf-67815.appspot.com/o/AD%2F%E5%90%88%E4%BD%9Clogo.png?alt=media&token=5fc7741c-b978-401d-92c0-0b1ac2aac34d',
          //   fun: () => (this.notifyGolfouritFormData.active = true),
          // },
          {
            text: 'ALBA',
            img:
              'https://firebasestorage.googleapis.com/v0/b/golf-67815.appspot.com/o/AD%2Fad_btn1.png?alt=media&token=38659f5b-b4f7-482e-a8e4-c38eea5df778',
            fun: () => this.toAdPage('ALBA'),
          },
          {
            text: '旅行社',
            img:
              'https://firebasestorage.googleapis.com/v0/b/golf-67815.appspot.com/o/AD%2Fad_btn2.png?alt=media&token=3000a557-95b9-418d-886c-d2bd4c42a5b0',
            fun: () => this.toAdPage('fumon'),
          },
          {
            text: '高爾夫雜誌',
            img:
              'https://firebasestorage.googleapis.com/v0/b/golf-67815.appspot.com/o/AD%2Fad_btn3.png?alt=media&token=91b79168-f90b-4395-bf40-a5b112526f16',
            fun: () => this.toAdPage('TaiwanGolf'),
          },
          // {
          //   text: 'TPGA',
          //   img:
          //     'https://lh3.googleusercontent.com/proxy/mX69JLNG43cwXR7dA5QQ-wuNMHZ5U7fawj95EcWDMT297T8BflI4X5VfZdtfILKrOQMZ6W3S4Dy4EsJ2kQdK402zGpY',
          //   fun: () => {
          //     this.liff.openWindow({
          //       url: 'https://liff.line.me/1650128613-PXabg9Lm',
          //       external: false,
          //     });
          //   },
          // },

          {
            text: 'Golf101',
            img: 'https://i1.wp.com/images.golf101.golf/golf/LOGO_512x512.png?w=512&ssl=1',
            fun: () => this.toAdPage('golf101'),
          },
        ],

        pgaData: [
          {
            title: 'The RSM Classic',
            winner: 'Robert Streb',
            pic:
              'https://firebasestorage.googleapis.com/v0/b/golf-67815.appspot.com/o/AD%2F1102.jpg?alt=media&token=b7248477-c19b-4ee8-a244-869ee575d76a',
            click: () =>
              window.open('https://www.youtube.com/watch?v=nRsP9fBiC80&ab_channel=PGATOUR'),
          },
          {
            title: 'Masters Tournament',
            winner: 'Dustin Johnson',
            pic:
              'https://firebasestorage.googleapis.com/v0/b/golf-67815.appspot.com/o/AD%2F1101.jpg?alt=media&token=76466533-f95d-4f6d-be63-9461950d5c68',
            click: () =>
              window.open('https://www.youtube.com/watch?v=VT4p9h9yN_g&ab_channel=TheMasters'),
          },
          {
            title: 'Vivint Houston Open',
            winner: 'Tyrrell Hatton',
            pic:
              'https://firebasestorage.googleapis.com/v0/b/golf-67815.appspot.com/o/AD%2F1100.jpg?alt=media&token=d82adda3-c808-4dc7-9bb4-4dfc1766eca8',
            click: () =>
              window.open('https://www.youtube.com/watch?v=IbGBFjBAwQs&ab_channel=PGATOUR'),
          },
        ],
      };
    },
    components: { notifyGolfouritForm, showOpenGameOption },
    computed: {
      ...mapGetters(['liffUserData', 'allCompetesDatas']),
      allCompetesDatasFilterJoin() {
        let data = [];
        for (let i in this.allCompetesDatas) {
          if (
            this.allCompetesDatas[i]['competeOrder'][this.liffUserData.userId] &&
            this.allCompetesDatas[i]['open_date'] == moment().format('YYYY-MM-DD')
          ) {
            let dataTem = JSON.parse(JSON.stringify(this.allCompetesDatas[i]));
            dataTem['allKey'] = i;
            data.push(dataTem);
          }
        }
        // console.log(data);
        return data;
      },
    },
    methods: {
      toRecordCardRouter(id) {
        this.$router.push(`/gameRecordCard/${id}`);
      },
      toPartnerPage() {
        window.location = 'https://golfourit.twdd.tw/';
      },
      toPartnerPagePxg() {
        window.location = 'https://www.pxgstore.com/?rcode=GOLFOURIT';
      },
      toAdPage(name) {
        this.$router.push({ path: `/adWeb/${name}` });
      },
      toCourseInfoPage() {
        this.$router.push({ name: 'courseInfo' });
      },
    },
  };
</script>

<style src="../assets/css/Home.css" scoped></style>
